import { Component } from '@angular/core';

import { SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';

@Component({
    selector: 'app-table-restart-dialog',
    templateUrl: './table-restart-dialog.component.html',
    styleUrls: ['./table-restart-dialog.component.scss'],
    standalone: false,
})
export class TableRestartDialogComponent {

    constructor(public dialogRef: SopoDialogRef) {}

    dismiss() {
        this.dialogRef.close();
    }
}
